import axios from 'axios';

/**
 * Centralized API configuration for the application.
 * Automatically resolves the Base URL based on the environment (Local vs Production).
 */
const isLocal = window.location.hostname === 'localhost' || window.location.hostname === '127.0.0.1';

const API = axios.create({
  baseURL: isLocal ? 'http://localhost:5000' : '',
  headers: {
    'Content-Type': 'application/json'
  }
});

// Adding common utility for error handling or interceptors if needed later
API.interceptors.response.use(
  (response) => response,
  (error) => {
    console.error('API Call Error:', error.response?.data || error.message);
    return Promise.reject(error);
  }
);

export default API;
